<template lang="pug">
  Icon.icon(name="notification-play" v-if="type === 'icon'")
  div(v-else-if="type === 'title'") Вы стали участником проекта
    Link(:to="{ name: 'project-stages', params: item.info }")  {{ item.info.projectName }}
</template>

<script>
export default {
  name: 'NotificationBecomeProjectMember',
  props: {
    item: Object,
    type: String,
  },
};
</script>

<style scoped>

</style>
